/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listLiabilityAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("liability/accounts/list", data);
    return response;
  },

  async listPaymentAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("income/payment-accounts/list", data);
    return response;
  },

  async addLiability(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("liability/add", data);
    return response;
  },

  async getLiabilityBalance() {
    let data = { source: "Web" };
    let response = await apiCall("liability/balance", data);
    return response;
  },

  async listRecentPayables() {
    let data = { source: "Web" };
    let response = await apiCall("liability/payables/recent", data);
    return response;
  },

  async listLiabilityBalances() {
    let data = { source: "Web" };
    let response = await apiCall("liability/balances/list", data);
    return response;
  },

  async reduceLiability(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("liability/reduce", data);
    return response;
  },
};
